import { clickUpdator } from "../../common/api";
import EventDispatcher from "../../common/EventDispatcher";

export default class AgeVerify {
  constructor() {
    document
      .querySelector("#age_sec #ageYes")
      .addEventListener("click", this.confirmAge.bind(this, true));
    document
      .querySelector("#age_sec #ageNo")
      .addEventListener("click", this.confirmAge.bind(this, false));
    document
      .querySelector("#age_sec #ageConfirm")
      .addEventListener("click", this.onAgeConfirm.bind(this));
  }
  init() {
    this.ageConfirmed = false;
    this.ageEligible = false;

    this.events = EventDispatcher.getObj();
    this.events.addEventListener("GAMESCENE_EVENTS", this.onEvents.bind(this));
  }
  onEvents(data) {
    switch (data["message"]["event_type"]) {
      case "show_screen":
        this.showScreen(data["message"]["data"]);
        break;
    }
  }
  showScreen(data) {
    if (data["screenKey"] !== "AgeVerify") return false;

    document.querySelector("#age_sec").classList.add("active");
  }
  confirmAge(ageEligible) {
    this.ageConfirmed = true;
    this.ageEligible = ageEligible;

    if (this.ageEligible) {
      document.querySelector("#age_sec #ageYes").classList.add("active");
      document.querySelector("#age_sec #ageNo").classList.remove("active");
    } else {
      document.querySelector("#age_sec #ageYes").classList.remove("active");
      document.querySelector("#age_sec #ageNo").classList.add("active");
    }

    document.querySelector("#ageConfirm").classList.add("active");
  }
  async onAgeConfirm() {
    if (!this.ageConfirmed) return false;

    // const res = await clickUpdator(false, "isLegalAge");
    if (!this.ageEligible) {
      this.showNotEligible();
    } else {
      this.showNextScreen();
    }
  }
  showNotEligible() {
    document.querySelector("#age_sec .buttons").style.display = "none";
    document.querySelector("#age_sec .title").innerHTML =
      "You are not eligible to participate in this promotion";
  }
  showNextScreen() {
    this.hideScreen();
    this.events.dispatchEvent({
      type: "GAMESCENE_EVENTS",
      message: {
        event_type: "show_screen",
        data: {
          screenKey: "Register",
        },
      },
    });
  }
  hideScreen() {
    document.querySelector("#age_sec").classList.remove("active");
  }
}
